<template>
    <div class="c-a-rating">
        <span v-for="index in 5" :key="`rating-${index}`" class="c-a-rating__value">
            <icon :icon="ratingObject(index)" class="c-a-rating__icon"></icon>
        </span>
        <span v-if="!ratingValue && showNr" class="c-a-rating__info">(0 st)</span>
        <span v-else-if="nrOfRatings && showNr" class="c-a-rating__info">({{ nrOfRatings }}st)</span>
    </div>
</template>
<script>
    import Icon from './AtomIcon.vue';

    export default {
        props: {
            nrOfRatings: {
                type: String|Number,
                default: null
            },
            ratingValue: {
                type: String|Number,
                default: 0
            },
            showNr: {
                type: Boolean,
                default: true
            }
        },
        components: {
            Icon
        },
        methods: {
            ratingObject(index){
                if ( (Math.round(this.ratingValue * 2) / 2) >= index){
                    return 'star'
                } else if ( (Math.round(this.ratingValue * 2) / 2) < index && (Math.round(this.ratingValue * 2) / 2) > (index - 1) ) {
                    return 'star_half'
                }
                return 'star_border'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomRating.vue